import { Dispatch, SetStateAction } from 'react';
import { ace_index } from '@axo/shared/data-access/types';
import { FilterSelect } from '../FilterSelect';
import { areObjectsDifferent } from '../../utils/compareObjects';
import { setPageNumber } from '../SearchResults';

interface Props {
  query: ace_index.FindInput;
  setQuery: Dispatch<SetStateAction<ace_index.FindInput>>;
  editable?: boolean;
}

export function NumLoanRequestsSentBetween({
  query,
  setQuery,
  editable = false,
}: Props) {
  const state = getNumLoanRequestsSent(query);
  const value =
    options.find((option) => !areObjectsDifferent(option.value, state)) ??
    options[0];

  return (
    <FilterSelect
      items={options}
      onSelect={(option) => setQuery(setNumLoanRequestsSent(option.value))}
      stringify={(option) => option.label}
      value={value}
      label="Number of loan requests sent"
      description="Filter applications by how many loan requests have been sent"
      disabled={!editable}
    />
  );
}

const options: {
  label: string;
  value: Value;
}[] = [
  {
    label: 'All',
    value: undefined,
  },
  {
    label: '0-2 requests',
    value: { To: 3 },
  },
  {
    label: '2+ requests',
    value: { From: 2 },
  },
  {
    label: '3+ requests',
    value: { From: 3 },
  },
];

function setNumLoanRequestsSent(
  range: Value
): SetStateAction<ace_index.FindInput> {
  return (query) => ({
    ...setPageNumber(1)(query),
    SummaryNumRegisteredLoanRequests: range,
  });
}

function getNumLoanRequestsSent(query: ace_index.FindInput) {
  return query.SummaryNumRegisteredLoanRequests;
}

type Value = ace_index.FindInput['SummaryNumRegisteredLoanRequests'];
